module.exports = {"id":"178323","name":"Abdou Razack Traoré","rating":"74","photo":"./data/images/photos/1/178323.png","club":{"name":"Konyaspor","logo":"./data/images/clubs/Konyaspor.png"},"positions":["MOC","MD","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AbdouRazackTraore0.json
// module id = 56
// module chunks = 0